import type { IQuestionsPageProps } from '$/pages/registration/questions';
import type { IQuestionPageContext } from './QuestionPageProvider';

import { useContext } from 'react';

import { QuestionPageContext } from './QuestionPageProvider';

export type IQuestionsPageStateProps = IQuestionPageContext;

const useQuestionsPage =
  ({}: IQuestionsPageProps): IQuestionsPageStateProps => {
    return useContext(QuestionPageContext);
  };

export default useQuestionsPage;
